import { Injectable } from '@angular/core';
import * as configCat from 'configcat-js';

/**
 * FeatureFlagService is a service that provides methods to check feature flags using ConfigCat.
 * The `configCatClient` object was initialized in the `health-check-feature-flag.js` in the main `index.html` file.
 */
declare global {
  interface Window {
    configCatClient?: configCat.IConfigCatClient;
  }
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private configCatClient!: configCat.IConfigCatClient;

  init(): void {
    this.configCatClient = window.configCatClient;

    console.log('ConfigCat client initialized', this.configCatClient);
  }

  async isFlagEnabled(feature: string): Promise<boolean> {
    await this.configCatClient.forceRefreshAsync();

    return this.configCatClient.getValueAsync(feature, false);
  }
}
